const GraphRange = props => (
  <div style={{ float: "left", width: props.width, textAlign: "left" }}>
    <div style={{ height: props.height, backgroundColor: props.color }} />
    <div style={{ fontSize: "12px", lineHeight: "16px", color: "#aeaeae" }}>{props.start}</div>
  </div>
);

export default GraphRange;
